const EnquiryApiUrl = {
    //#region EnquiryNow
    AddEnquiryNow: "api/Enquiry/AddEnquiryNow",
    //#endregion

}
export default EnquiryApiUrl;